import React, { useCallback, useEffect, useMemo, useState } from "react"
import { getDisableGroupByOptions, aggregationOptions as options } from '../../utils/aggregationUtils'
import Select from "../ui/Select"
import { useDataset } from "../../context/dataset"
import { useSection } from "../../context/section"
import useGranularity from "../../hooks/useGranularity"
import AutocomplateButton from "../ui/AutocomplateButton"
import SelectButton from "../ui/alternativeData/SelectButton"
import { Grid, Paper } from '@mui/material'
import styles from './Dropdown.module.scss'


const GridItem = (props) => {
    return (
        <Grid item xs={6} md={3} {...props}>
            {props.children}
        </Grid>
    )
}

export default function KpiEditor({dataset, index, ticker, financialInfo}) {
    
    const { originalFrequency } = useDataset()
    const { granularityOptions } = useGranularity(dataset[index]?.datasetValue, ticker)
    const { setSelectedAggregationBy, setSelectedGroupBy, setSelectedGranularity } = useSection()
    const [ currentAgg, setcurrentAgg] = useState(dataset[index]?.agg)
    const [ currentGroupBy, setcurrentGroupBy] = useState(dataset[index]?.group || originalFrequency)

    const selectAgg = (_, e) => setSelectedAggregationBy(e.props.value, index)
    const selectGroup = (_, e) => setSelectedGroupBy(e.props.value, index, originalFrequency)
    const selectGranularity = (values, optionValue) => setSelectedGranularity(values, index, optionValue)

    // const currentGroupBy = useMemo(()=>dataset[index]?.group || originalFrequency,[dataset,financialInfo]) 

    // const currentAgg = useMemo(()=>dataset[index]?.agg,[dataset,financialInfo])

    const disableGroupByOptions = useMemo(() => getDisableGroupByOptions(originalFrequency),[originalFrequency])

    const granularitySelect = useMemo(() => {
        return granularityOptions?.map(
            ({name, value, options}) => 
                <GridItem key={value}>
                    <Paper elevation={2}>
                        <GranularitySelect 
                            key={`${dataset[index]?.datasetValue}-${value}`} 
                            labelName={name} 
                            labelValue={value} 
                            options={options} 
                            selectGranularity={selectGranularity} 
                            selectedOptions={dataset[index].granularity[value]}
                        />
                    </Paper>
                </GridItem>)
    } ,[granularityOptions, dataset]) // eslint-disable-line

    useEffect(()=>{
        setcurrentAgg(dataset[index]?.agg)
        setcurrentGroupBy(dataset[index]?.group || originalFrequency)
        return () => {}
    },[dataset,financialInfo])

    return (
        <>
            {(currentGroupBy) &&
            <>
                <Grid container spacing={3} classes={{root: styles['kpi-conatiner']}}>
                    {granularitySelect}
                </Grid>
                <Grid container spacing={3} classes={{root: styles['kpi-conatiner']}}>
                    <GridItem key="Group By">
                        <Select options={disableGroupByOptions} selectedValue={currentGroupBy} setSelectedValue={selectGroup} label="Group By" key='kpi_select_group'/>
                    </GridItem>
                    <GridItem key="Aggregation By">
                        <Select options={options.agg} disable={currentGroupBy === originalFrequency} selectedValue={currentAgg} setSelectedValue={selectAgg} label="Aggregation By" key='kpi_select_agg'/>
                    </GridItem>
                </Grid>
            </>}
        </>
    )
}

const GranularitySelect = ({labelName, labelValue, options, selectGranularity, selectedOptions}) => {
    const getOptionNameByValue = useCallback((optionValue) => options.find(({value}) => optionValue === value )?.name, [options])
    const selectedUI = useMemo(() =>  options && selectedOptions?.map((optionValue) => getOptionNameByValue(optionValue)) ,[selectedOptions, options, getOptionNameByValue])

    const update = (values) => selectGranularity(values, labelValue)

    return (
        <AutocomplateButton 
        options={options} 
        value={selectedOptions ?? []} 
        setValue={update}
        name={labelValue}
        shouldHaveAll
        >
            <SelectButton 
                value={selectedUI?.join(' ')} 
                label={labelName}
                elevation={10}
                extraStyles={{button: [styles['select']], label: [styles['select-label']], arrow: [styles['select-arrow']]}} 
            />
        </AutocomplateButton>  
    )
}